export const cameraAddOns = {
  streaming: 'live_streaming',
}

export const apiCameraAddOns = {
  streaming: 'Streaming',
}
